import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'

const whiteList = ['/login', '/choose-branch'] // allow branch choose page without redirect

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      
      // check if user info already loaded
      if (!store.getters.role) {
        try {
          // fetch user info (roles, menus, branches, etc.)
          const res = await store.dispatch('GetInfo')
          const menus = res.data.menus
          const branches = res.data.branches || [] // assume your backend returns this array

            // Generate routes after confirming branch
          await store.dispatch('GenerateRoutes', { menus, roleId: res.data.roleId })
          store.getters.addRouters.forEach(r => router.addRoute(r))
            // 🔹 2. Handle role-based logic
          if (res.data.roleId === 1) {
            // const accessedRouters = await store.dispatch('GenerateRoutes', { menus })
            // accessedRouters.forEach(r => router.addRoute(r))

            next({ path: '/admin', replace: true })
            NProgress.done()
            return
          }


          // If user has multiple branches, redirect to branch selection page
          if (branches.length > 1 && to.path !== '/choose-branch') {
            next({ path: '/choose-branch' })
            NProgress.done()
            return
          }

          next({ ...to, replace: true })
        } catch (err) {
          await store.dispatch('FedLogOut')
          Message.error(err || 'Verification failed, please login again')
          next({ path: '/' })
          NProgress.done()
        }
      } else {
        if(store.getters.addRouters.length === 0) {
          await store.dispatch('GenerateRoutes', { menus: store.getters.menus })
          store.getters.addRouters.forEach(r => router.addRoute(r))
        }
        next()
        NProgress.done()
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
